module.exports = __webpack_public_path__ + "img/chart.417b6ea0.png";